import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'modal-specs',
  templateUrl: './modal-specs.component.html',
  styleUrls: ['./modal-specs.component.sass']
})
export class ModalSpecsComponent implements OnInit {
  public component = window.location.protocol + '//' + window.location.host + '/design-specs-measure/modal/';
  constructor() { }

  ngOnInit(): void {
  }

  clickEvent(route) {
    if(route == 'light') {
      window.open(this.component, "_blank");
    }
  }

}
